<template>
  <div>
    <div class="top_container top_Wrapper">
      <ul>
        <li>
          <a href="https://detail.91jf.com/transport" target="_blank">运费计算</a>
          <a-divider type="vertical" />
        </li>
        <!-- <li>
          <a href="/express/send">寄快递</a>
          <a-divider type="vertical" />
        </li> -->
        <li>
          <a-dropdown placement="bottomCenter">
            <span>
              功能服务
              <a-icon type="down" />
            </span>
            <a-menu slot="overlay">
              <!-- <a-menu-item>
                <a href="https://detail.91jf.com/help/35" target="_blank">淘宝一键上传</a>
              </a-menu-item> -->
              <a-menu-item>
                <a href="https://www.91jf.com/default.php?act=publish" target="_blank">快速发布信息</a>
              </a-menu-item>
              <a-menu-item>
                <a-tooltip placement="right" arrowPointAtCenter title="点击右键，选择“目标另存为...”，将此快捷方式保存到桌面即可">
                  <a href="https://detail.91jf.com/desktop">保存到桌面</a>
                </a-tooltip>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-divider type="vertical" />
        </li>
        <li>
          <a class="text_red" href="https://detail.91jf.com/service/1" target="_blank">服务条款</a>
        </li>
      </ul>
      <ul>
        <li>
          <img src="~@/assets/images/basic/ic_home.png" width="16px" height="16px" />
          <a class="ml8" href="https://www.91jf.com/" target="_blank">91家纺网首页</a>
          <a-divider type="vertical" />
        </li>
        <li>
          <img src="~@/assets/images/basic/ic_shopping_cart.png" width="16px" height="16px" />
          <a class="ml8" href="/cart">采购车<template>({{ cart_num }})</template></a>
          <a-divider type="vertical" />
        </li>
        <li>
          <img src="~@/assets/images/basic/ic_order.png" width="16px" height="16px" />
          <a class="ml8" href="/order/list">我的订单</a>
          <a-divider type="vertical" />
        </li>
        <li>
          <a href="/notice">短消息</a>
          <a-divider type="vertical" />
        </li>
        <li>
          <a-dropdown placement="bottomCenter">
            <span>客户服务
              <a-icon type="down" />
            </span>
            <a-menu slot="overlay">
              <a-menu-item @click.native="kefu"><img :src="require('@/assets/images/basic/top_kf.png')" alt=""
                  class="top_kf">
                在线客服
              </a-menu-item>
              <a-menu-item class="cursor_default">
                <span>电话：400-999-8591</span>
              </a-menu-item>
              <a-menu-item class="cursor_default">
                <span>商务邮箱：business@91jf.com</span>
              </a-menu-item>
              <!-- v-if="$route.matched[0].path === '/deal'" -->
              <a-menu-item>
                <div class="qrcode_box">
                  <img src="~@/assets/images/basic/qrcode_kf.png" width="82px" height="82px" />
                  <div class="qrcode_desc">
                    <span class="text_orange">导单客服</span>
                    <span>微信扫一扫</span>
                    <span>帮您轻松下单</span>
                  </div>
                </div>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-divider type="vertical" />
        </li>
        <li>
          <a-dropdown placement="bottomCenter">
            <span>手机91
              <a-icon type="down" />
            </span>
            <a-menu slot="overlay" class="mobile_91">
              <a-menu-item>
                <div class="qrcode_box">
                  <img src="~@/assets/images/basic/qrcode_app.png" width="82px" height="82px" />
                  <div class="qrcode_desc">
                    <span class="text_orange">91家纺app</span>
                    <a-space :size="5" class="mt10">
                      <a href="https://itunes.apple.com/cn/app/id1109299296" target="_blank" class="flex_v_center"><img
                          src="~@/assets/images/basic/ios.png" width="13px" height="13px" />苹果</a>
                      <a href="https://www.91jf.com/attachment/app/91jf.apk" class="flex_v_center"><img
                          src="~@/assets/images/basic/android.png" width="13px" height="13px" />安卓</a>
                    </a-space>
                  </div>
                </div>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <a-divider type="vertical" />
        </li>
        <li>
          <span @click="toInfo">{{
            userinfo == null ? "" : userinfo.nickname
          }}</span>
        </li>
        <li>
          <span @click="logout" class="ml8">［退出］</span>
        </li>
      </ul>
    </div>
    <div v-if="adv && adv.img" class="top_adv" :style="style">
      <a @click="toUrl">
        <img :src="adv.img" style="margin-left: 400px;max-height: 100px;" />
      </a>
    </div>
    <kefu-tools v-if="showTools"></kefu-tools>
    <ke-fu ref="kefu"></ke-fu>
  </div>

</template>

<script>
import KefuTools from '@/components/common/KefuTools'
import KeFu from '@/components/common/KeFu.vue'

export default {
  name: "BasicTop",
  components: {
    KefuTools,
    KeFu
  },

  props: ['Resize'],

  data() {
    return {
      cart_num: 0,
      userinfo: null,
      showTools: 1,
      adv: {},
      style: 'width:100%;',
      midPostion: false,
    };
  },
  created() {
    if (this.Resize) {
      this.midPostion = true
    }

    if (this.$route.path == '/' || this.$route.path == '/home') {
      this.showTools = 0;
    }
    this.getUserInfo();
    this.getCartNum();
  },
  methods: {
    getUserInfo() {
      var _this = this;
      // var userinfo = _this.$util.userinfo();

      // if (userinfo == null) {
      _this.$util.api("/login/status", {}, function (res) {
        if (res.code == 10000) {
          _this.userinfo = res.data;
          _this.adv = res.data.top_adv;
          if (_this.adv.color != '') {
            _this.style += 'background-color:' + _this.adv.color;
          }

          // _this.$cookies.set("UserInfo", res.data);
        } else {
          _this.$router.push("/login");
        }
      });
      // } else {
      //   this.userinfo = userinfo;
      // }
    },
    getCartNum() {
      var _this = this;
      _this.$util.api("/cart/num", {}, function (res) {
        if (res.code == 10000) {
          _this.cart_num = res.data;
        }
      });
    },
    logout() {
      this.$util.api("/login/logout", {}, res => {
        this.$message[res.code == 10000 ? 'success' : 'error'](res.msg);

        if (res.code == 10000) {
          this.$cookies.remove("UserInfo");
          this.$cookies.remove("AccessToken");
          this.$cookies.remove("mobile");
          this.$cookies.remove("EndTime");
          this.$cookies.remove("AccessToken", '', '91jf.com');
          // this.$router.push("/login");
          window.location.href = this.$util.getHost() + 'default.php?url=member&act=logout'
        }
      });
    },
    kefu() {
      // this.$kefu();
      this.$refs.kefu.open();
    },
    toInfo() {
      this.$router.push("/info");
    },
    toUrl() {
      var _this = this;

      if (_this.adv.id > 0) {
        _this.$util.api('/adv/click', { adv_id: _this.adv.id, url: _this.adv.url }, function (res) {

        });
      }
      window.open(_this.adv.url, '_blank');
    }
  },
};
</script>

<style scoped>
.top_container {
  background: #F8F7F7;
  padding: 10px 23px;
  padding-right: 11px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
}

.top_Wrapper {
  width: 1400px;
  margin: 0 auto;
}

.top_container>>>.ant-divider {
  color: #979797;
  background: #979797;
}

.top_container ul {
  display: flex;
  align-items: center;
}

.top_container ul li {
  height: 18px;
  font-size: 12px;
  color: #666666;
  line-height: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.top_container ul li:hover {
  color: #fd5902;
}

.text_red {
  color: #d0021b;
}

.ml8 {
  margin-left: 8px;
}

.cursor_default {
  cursor: default;
}

.qrcode_box {
  display: flex;
  align-items: center;
  cursor: default;
}

.qrcode_desc {
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}

.ant-dropdown-menu-item {
  font-size: 12px;
}

.mobile_91>>>.ant-dropdown-menu-item:hover,
.ant-dropdown-menu-submenu-title:hover {
  color: unset;
}

a {
  font-size: 12px;
}

.top_kf {
  width: 18px;
  height: 18px;
}

@media screen and (max-width: 1400px) {
  .top_Wrapper {
    width: 100%;
    margin: 0 auto;
  }

  .ant-dropdown-menu-item>a,
  .ant-dropdown-menu-item {
    font-size: 8px;
  }

  .top_kf {
    width: 10px;
    height: 10px;
  }
}

/* @media screen and (max-width: 1279px) {
  .top_Wrapper {
    width: 100%;
    margin: 0 auto;
  }

  .ant-dropdown-menu-item>a,
  .ant-dropdown-menu-item {
    font-size: 7px;
  }

  .top_kf {
    width: 8px;
    height: 8px;
  }
}


@media screen and (min-width: 1280px) and (max-width: 1400px) {
  .top_Wrapper {
    width: 100%;
    margin: 0 auto;
  }

  .ant-dropdown-menu-item>a,
  .ant-dropdown-menu-item {
    font-size: 8px;
  }

  .top_kf {
    width: 10px;
    height: 10px;
  }
}


@media screen and (min-width: 1440px) and (max-width: 1600px) {

  .top_Wrapper {
    width: 100%;
    margin: 0 auto;
  }

  .ant-dropdown-menu-item>a,
  .ant-dropdown-menu-item {
    font-size: 10px;
  }

  .top_kf {
    width: 16px;
    height: 16px;
  } */
/* } */
</style>



// WEBPACK FOOTER //
// src/components/common/basic/BasicTop.vue